import { MetadataLoaderConnection, PreviewLoaderConnection } from "./metadata-loader-connection"

export const MetadataLoader = await MetadataLoaderConnection.connect()

export const PreviewLoader = await PreviewLoaderConnection.connect()
PreviewLoader.setOptions({ jobs: 2 })
